'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoBoxStyled = undefined;

var _templateObject = _taggedTemplateLiteral(['\n        padding-left: calc(', ' + ', ' + ', ');\n      '], ['\n        padding-left: calc(', ' + ', ' + ', ');\n      ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var propTypes = {
  /**
   * Full-width TextField doesn't have borders
   */
  fullWidth: _propTypes2.default.bool,

  /**
   * If textfield is dense it has smaller paddings
   */
  dense: _propTypes2.default.bool,

  /**
   * Define label position
   */
  labelPosition: _propTypes2.default.oneOf(['top', 'side']),

  /**
   * Add icon behind textfield
   */
  iconOuter: _propTypes2.default.element,

  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  disabled: false,
  fullWidth: false,
  dense: false,
  labelPosition: 'top',
  iconOuter: null
};
/** PROP RECEIVERS */

var offset = function offset(_ref) {
  var themeFromProvider = _ref.theme,
      labelPosition = _ref.labelPosition,
      dense = _ref.dense,
      fullWidth = _ref.fullWidth,
      iconOuter = _ref.iconOuter,
      bordered = _ref.bordered;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var labelPositionSide = theme.reactackle.components.textfield.label.positionSide,
      labelPositionSideSizeType = bordered ? 'bordered' : 'underlined',
      labelPositionSideSize = labelPositionSide.size[labelPositionSideSizeType],
      iconOuterPath = theme.reactackle.components.textfield.iconOuter;
  var labelSizeSource = labelPositionSideSize;
  var iconSizeSource = iconOuterPath.size;

  if (dense && !fullWidth) {
    labelSizeSource = labelPositionSideSize.dense;
    iconSizeSource = iconOuterPath.size.dense;
  } else if (dense && fullWidth) {
    labelSizeSource = labelPositionSideSize.denseFullWidth;
    iconSizeSource = iconOuterPath.size.denseFullWidth;
  } else if (!dense && fullWidth) {
    labelSizeSource = labelPositionSideSize.fullWidth;
    iconSizeSource = iconOuterPath.size.fullWidth;
  }

  var labelSpacing = (0, _reactackleCore.getValueString)(labelSizeSource.labelSpacing),
      iconSpacing = (0, _reactackleCore.getValueString)(iconOuterPath.iconSpacing),
      boxSize = (0, _reactackleCore.getValueString)(iconSizeSource.boxSize),
      width = (0, _reactackleCore.getValueString)(labelPositionSide.width),
      iconOffset = iconOuter ? 'calc(' + boxSize + ' + ' + iconSpacing + ')' : 0;
  var breakpoints = labelPositionSide.breakpoints.map(function (item) {
    var width = (0, _reactackleCore.getValueString)(item.width);
    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, width, labelSpacing, iconOffset));
  });
  var defaultOffset = 'calc(' + width + ' + ' + labelSpacing + ' + ' + boxSize + ')';
  return labelPosition === 'side' ? (0, _styledComponents.css)(['padding-left:', ';', ';'], defaultOffset, breakpoints) : iconOffset && 'padding-left: ' + iconOffset + ';';
};
/** STYLES */


var InfoBoxStyled = exports.InfoBoxStyled = _styledComponents2.default.div.withConfig({
  displayName: 'InfoBoxStyled'
})(['display:flex;justify-content:flex-end;', ';'], offset);

InfoBoxStyled.propTypes = propTypes;
InfoBoxStyled.defaultProps = defaultProps;
InfoBoxStyled.displayName = 'InfoBoxStyled';